<h2>Scattergories Rules</h2>
<p>This simple game will test your vocabulary and quick thinking!</p>
<ol>
  <li>Each player will receive 12 categories and a letter</li>
  <li>Users will enter a word or phrase that starts with that letter that they think fits into that category.
    <ul>
      <li>Ex: Category is Fruit, Letter is K: User enters the work "Kiwi"</li>
    </ul>
  </li>
  <li>Users can enter up to 3 words per category, simply press enter or tab after each word/phrase you submitted and enter another one</li>
</ol>
<p><strong>Game Twists</strong></p>
<ul>
  <li>You only have 3 minutes to submit as many words/phrases as you can.</li>
  <li>After everyone has submitted, your friends will vote on whether or not to accept your answers</li>
  <li>If there are duplicate answers, your friends will likely not accept your answer.</li>
  <li>You get extra points for alliteration!! Ex: Wrestlers - "Hulk Hogan" is 2 points instead of 1!</li>
</ul>

<p><strong>Person with the most points at the of voting wins! Check this host screen to see who the winner is!</strong></p>
